// extracted by mini-css-extract-plugin
export default {"placeholder":"grey-pin-place_placeholder__jie0+"};